import {SurveyFieldCreate, SurveyFieldResource} from '@/interfaces';
import {CrudApiAbstract} from '@/api/CrudApiAbstract';
import {ResourceType} from '@/enums';

export class SurveyFieldApi extends CrudApiAbstract<
  SurveyFieldResource,
  SurveyFieldCreate
> {
  public constructor() {
    super(`${ResourceType.SurveyField}s`);
  }
}
